import { render, staticRenderFns } from "./GestioneLavorazione.vue?vue&type=template&id=ec7b0580&"
import script from "./GestioneLavorazione.vue?vue&type=script&lang=js&"
export * from "./GestioneLavorazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports